var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_ADMIN_RECHARGE_REQUEST, updateAdminRechargeDataFailure, updateAdminRechargeDataSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const updateAdminRecharge = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const data = action.payload;
        try {
            APIIN.post(`pmnt/admin/wallet/recharge`, data)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* createUpdateAdminRechargeWorker(action) {
    try {
        const data = yield call(updateAdminRecharge, action);
        yield put(updateAdminRechargeDataSuccess(data));
    }
    catch (error) {
        yield put(updateAdminRechargeDataFailure(error));
    }
}
export function* watchUpdateAdminRechargeData() {
    yield takeLatest(UPDATE_ADMIN_RECHARGE_REQUEST, createUpdateAdminRechargeWorker);
}
